
<template>
    <v-container class="pa-0">
      <v-card flat :class="cardClass">
        <v-card-title primary-title class="justify-center">
          <div class="pb-3 headline font-weight-medium ">Passwort zurücksetzen</div>
        </v-card-title>
        <v-card-subtitle class="text-center pb-0"></v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid">

              <!-- Passwort old -->
              <v-col v-if="token==null" cols="12" > 
                <v-text-field 
                outlined 
                :disabled="app_loading"
                hide-details
                v-model="passwordOld"
                label="Altes Passwort"
                :rules="passwordRules"
                :append-icon="showPasswordOld ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPasswordOld ? 'text' : 'password'"
                @click:append="showPasswordOld = !showPasswordOld"
                ></v-text-field> 
              </v-col>
              <!-- Password new -->
              <v-col cols="12" > 
                <v-text-field 
                outlined 
                :disabled="app_loading"
                hide-details
                @keydown.enter="changePasswordByUser"
                v-model="password"
                label="Neues Passwort"
                :rules="passwordRules"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                ></v-text-field> 
              </v-col>
              <v-row >
                <v-col cols="12" align="center"> 
                  <v-btn class="ma-2 text-transform-none" depressed small :loading="app_loading" color="primary" @click="changePasswordByUser" tile >Passwort ändern</v-btn>
                  <div v-if="change_password_error" class="red--text">Dein Passwort konnte leider nicht geändert werden</div>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
  import {settingsMixin} from '@/utils/settings-mixin'
  import {validationMixin} from '@/utils/validation-mixin'
  export default {
    mixins:[settingsMixin,validationMixin],
    components:{

    },
    props:{
      token:{
        type:String,
        default:null
      },
      cardClass:{
        type:String
      }
    },
    data: () => ({
      password:'',
      passwordOld:'',
      showPassword: false,
      showPasswordOld:false,
      change_password_error: false,
      valid: true
    }),
    computed:{
      changePasswordData(){
        return {
          email:null,
          newPassword:this.password,
          oldPassword:this.passwordOld,
          token:this.token
        }
      },
    },
    methods:{
      validate () {
        this.$refs.form.validate()
      },
      reset(){
        this.$refs.form.reset();
      },
      changePasswordByUser(){

        if(!this.valid){
          this.validate();
          return;
        }

        this.change_password_error=false;
        this.changePassword(this.changePasswordData).then(()=>{
          this.reset();
          this.$emit('next');
        }).catch((ex) => {
          console.log(ex);
          console.log('Change password error');
          this.change_password_error=true;
        });
      }
    }
  }
</script>

<style scoped>

.container{
  max-width: 600px;
}

</style>